import { Button } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled, { createGlobalStyle } from 'styled-components';

export const ClusterPopupStyles = createGlobalStyle`
  .cluster-popup {
    .mapboxgl-popup-tip {
      display: none;
    }

    .mapboxgl-popup-content {
      padding: 0;
      background: transparent;
      box-shadow: none;
    }
  }
`;

export const Container = styled.article`
  display: flex;
  flex-direction: column;
  width: 300px;
  max-height: 300px;
  border-radius: 8px;
  overflow: hidden;
  background-color: ${COLOR_OPTIONS.WHITE};
  border: 1px solid ${COLOR_OPTIONS.NEUTRAL_30};
  box-shadow: 0px 4px 20px 0px rgba(112, 115, 116, 0.16);

  & > ul {
    max-height: 260px;
  }
`;

export const CloseButton = styled(Button)`
  && {
    padding: 0;
    width: 20px;
    height: 20px;
    min-width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;

    &:hover {
      background: ${COLOR_OPTIONS.NEUTRAL_10};
    }

    svg {
      width: 12px;
      height: 12px;
      fill: ${COLOR_OPTIONS.NEUTRAL_50};
    }
  }
`;
